<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="groups"
      :search="keyword"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Assign Templates</v-toolbar-title>
        </v-toolbar>
      </template>

      <template v-slot:item.courtesy="{ value, item }">
        <v-select
          :items="courtesyTemplates"
          :success="success"
          v-model="item.courtesy"
          item-text="text"
          item-value="value"
          :class="{ selectedRow: item.courtesyUnSaved === true }"
          @change="changeDirtyFlag(item, 'courtesy')"
        ></v-select>
      </template>
      <template v-slot:item.reminder1="{ value, item }">
        <v-select
          :items="reminder1Templates"
          :success="success"
          v-model="item.reminder1"
          item-text="text"
          item-value="value"
          :class="{ selectedRow: item.reminder1UnSaved === true }"
          @change="changeDirtyFlag(item, 'reminder1')"
        ></v-select>
      </template>
      <template v-slot:item.reminder2="{ value, item }">
        <v-select
          :items="reminder2Templates"
          :success="success"
          v-model="item.reminder2"
          item-text="text"
          item-value="value"
          :class="{ selectedRow: item.reminder2UnSaved === true }"
          @change="changeDirtyFlag(item, 'reminder2')"
        ></v-select>
      </template>
      <template v-slot:item.reminder3="{ value, item }">
        <v-select
          :items="reminder3Templates"
          :success="success"
          v-model="item.reminder3"
          item-text="text"
          item-value="value"
          :class="{ selectedRow: item.reminder3UnSaved === true }"
          @change="changeDirtyFlag(item, 'reminder3')"
        ></v-select>
      </template>
      <template v-slot:item.restrictNotice="{ value, item }">
        <v-select
          :items="restrictNoticeTemplates"
          :success="success"
          v-model="item.restrictNotice"
          item-text="text"
          item-value="value"
          :class="{ selectedRow: item.restrictNoticeUnSaved === true }"
          @change="changeDirtyFlag(item, 'restrictNotice')"
        ></v-select>
      </template>
      <template v-slot:item.action="{ value, item }">
        <v-btn color="primary" class="text-uppercase" @click="submit(item)"
          >Save</v-btn
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AssignTemplates",
  data: () => ({
    success: false,
    excludedGroups: null,
    templates: [],
    courtesyTemplates: [],
    reminder1Templates: [],
    reminder2Templates: [],
    reminder3Templates: [],
    restrictNoticeTemplates: [],
    search: "",
    headers: [
      { text: "Group Number", value: "groupNumber", sortable: false },
      { text: "Group Name", value: "groupName", sortable: false },
      { text: "Courtesy", value: "courtesy", align: "center", sortable: false },
      { text: "Reminder 1", value: "reminder1", sortable: false },
      { text: "Reminder 2", value: "reminder2", sortable: false },
      { text: "Reminder 3", value: "reminder3", sortable: false },
      { text: "Restrict Notice", value: "restrictNotice", sortable: false },
      { text: "Action", value: "action", sortable: false }
    ],
    groups: []
  }),
  computed: {
    ...mapGetters("search", ["keyword"]),
    pageChanged() {
      if (this.groups.length > 0) {
        var x;
        var groups = this.groups;
        for (x in groups) {
          if (
            groups[x].courtesyUnSaved ||
            groups[x].reminder1UnSaved ||
            groups[x].reminder2UnSaved ||
            groups[x].reminder3UnSaved ||
            groups[x].restrictNoticeUnSaved
          ) {
            return true;
          }
        }
      }
      return false;
    }
  },
  methods: {
    ...mapActions("template", [
      "getTemplates",
      "listGroupTemplates",
      "updateGroupTemplate"
    ]),
    loadTemplates() {
      let vm = this;
      this.getTemplates().then(data => {
        vm.templates = data;
        vm.templates.forEach(function(template) {
          if (template.stage == "Courtesy") {
            vm.courtesyTemplates.push({
              text: template.name,
              value: template.id
            });
          } else if (template.stage == "Reminder 1") {
            vm.reminder1Templates.push({
              text: template.name,
              value: template.id
            });
          } else if (template.stage == "Reminder 2") {
            vm.reminder2Templates.push({
              text: template.name,
              value: template.id
            });
          } else if (template.stage == "Reminder 3") {
            vm.reminder3Templates.push({
              text: template.name,
              value: template.id
            });
          } else if (template.stage == "Restrict Notice") {
            vm.restrictNoticeTemplates.push({
              text: template.name,
              value: template.id
            });
          }
        });
      });
    },
    loadData() {
      let vm = this;
      vm.listGroupTemplates().then(data => {
        vm.excludedGroups = data.filter(i => i.name !== null);
        if (vm.excludedGroups != null && vm.excludedGroups.length > 0) {
          vm.excludedGroups.forEach(function(group) {
            vm.groups.push({
              id: group.id,
              groupId: group.groupId,
              groupNumber: group.groupNumber,
              groupName: group.groupName,
              courtesy: group.courtesy,
              reminder1: group.reminder1,
              reminder2: group.reminder2,
              reminder3: group.reminder3,
              restrictNotice: group.restrictNotice,
              courtesyUnSaved: false,
              reminder1UnSaved: false,
              reminder2UnSaved: false,
              reminder3UnSaved: false,
              restrictNoticeUnSaved: false
            });
          });
        }
      });
    },
    changeDirtyFlag(item, type) {
      if (type === "courtesy") {
        item.courtesyUnSaved = true;
      } else if (type === "reminder1") {
        item.reminder1UnSaved = true;
      } else if (type === "reminder2") {
        item.reminder2UnSaved = true;
      } else if (type === "reminder3") {
        item.reminder3UnSaved = true;
      } else if (type === "restrictNotice") {
        item.restrictNoticeUnSaved = true;
      }
    },
    submit(item) {
      this.resetDirtyFlag(item);
      this.updateGroupTemplate(item).then(data => {
        if (data.length != 0) {
        } else {
          this.error = true;
        }
      });
    },
    confirmLeave() {
      return window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
    },
    confirmStayInDirtyForm() {
      return this.pageChanged && !this.confirmLeave();
    },
    beforeWindowUnload(e) {
      if (this.confirmStayInDirtyForm()) {
        // Cancel the event
        e.preventDefault();
        // Chrome requires returnValue to be set
        e.returnValue = "";
      }
    },
    resetDirtyFlag(item) {
      item.courtesyUnSaved = false;
      item.reminder1UnSaved = false;
      item.reminder2UnSaved = false;
      item.reminder3UnSaved = false;
      item.restrictNoticeUnSaved = false;
    },
    onChange(item, index, templates, type) {
      var name = templates.find(function(template) {
        return template.value == index;
      });
      item[type] = name.text;
    }
  },
  created() {
    window.addEventListener("beforeunload", this.beforeWindowUnload);
    setTimeout(() => {
      this.loadTemplates();
      this.loadData();
    }, 100);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeWindowUnload);
  },
  beforeRouteLeave(to, from, next) {
    // If the form is dirty and the user did not confirm leave,
    // prevent losing unsaved changes by canceling navigation
    if (this.confirmStayInDirtyForm()) {
      next(false);
    } else {
      // Navigate to next view
      next();
    }
  }
};
</script>

<style scoped>
.selectedRow {
  background-color: rgb(81, 113, 142);
}
</style>
